module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAPhJREFUOE9jZKAQMFKonwHFgPnz50skJia+wGXookWLuD98+MCcl5f3CaYGbgBI869fvy4yMjKGpaWlHUQ3pK+vT4ibm3v3v3//pmZmZs7DMAAkMGvWLPv///+vQjcEpvn///+7MzIyKpANxwgDdEPwaQYZhDUQkQzJ+P//fw02m7F6Adlp06dPD2RiYlrHwMCwLD09PRpXwGJ1AczZDAwMNxgYGFxwBSxWL6D7GVfAYvUCrgDDZwjcC6BE8v3790O4AgxmyP///wMyMjKOY7hg0qRJfKysrCHIiQQ94GbMmGHJyMj4Lz09/STBWCA2j1A3MxFrK7I6ABlelBEaDN7lAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/login/icon_清除.png
// module id = IGrd
// module chunks = 1